(function () {
  var root = document.getElementById('dnb-top');
  if (!root) return;
  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return document.querySelectorAll(s); };
  var d = root.dataset;
  var capPrice = +d.capPrice, drinkPrice = +d.drinkPrice; // cents
  var box = capPrice + drinkPrice;
  var tiers = {
    six: { boxes: 3, pct: +d.sixPct, code: d.sixCode, label: '6-month supply' },
    two: { boxes: 1, pct: +d.twoPct, code: d.twoCode, label: '2-month supply' }
  };
  var fmt = function (cents) {
    var amount = (cents / 100).toFixed(2);
    var f = d.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
            .replace(/\{\{\s*amount\s*\}\}/, amount);
  };
  var full = function (k) { return box * tiers[k].boxes; };
  var price = function (k) { return Math.round(full(k) * (1 - tiers[k].pct / 100)); };
  var perDay = function (k) { return price(k) / (tiers[k].boxes * 60); };

  ['six', 'two'].forEach(function (k) {
    $('[data-full="' + k + '"]').textContent = fmt(full(k));
    $('[data-price="' + k + '"]').textContent = fmt(price(k));
    $('[data-day="' + k + '"]').textContent = fmt(perDay(k)) + '/day · save ' + fmt(full(k) - price(k)) + ' (' + tiers[k].pct + '%)';
  });
  $$('[data-day-inline]').forEach(function (e) { e.textContent = fmt(perDay('six')); });
  $$('[data-save-inline]').forEach(function (e) { e.textContent = 'Save up to ' + tiers.six.pct + '% today'; });

  var current = function () { return $('input[name="dnb-plan"]:checked').value; };
  function sync() {
    var k = current(), t = tiers[k], p = price(k), b = t.boxes;
    $('#dnb-stack').innerHTML =
      '<div><span>Day &amp; Night Capsules × ' + b + '</span><span>' + fmt(capPrice * b) + '</span></div>' +
      '<div><span>Sleep Drink Mix × ' + b + '</span><span>' + fmt(drinkPrice * b) + '</span></div>' +
      '<div><span>US shipping</span><span class="f">FREE</span></div>' +
      '<div><span>30-Night Sleep Guarantee</span><span class="f">INCLUDED</span></div>';
    $('#dnb-cta-sub').textContent = fmt(p) + ' · ' + t.label + ' · save ' + fmt(full(k) - p);
    $('#dnb-st-price').textContent = fmt(p);
    $('#dnb-st-save').textContent = t.label + ' · save ' + t.pct + '%';
    $('#dnb-badge').textContent = 'SAVE ' + t.pct + '%';
  }
  $$('input[name="dnb-plan"]').forEach(function (r) { r.addEventListener('change', sync); });
  sync();

  // Add both products (× boxes) to cart, apply the tier's code, go to checkout
  function buy(e) {
    e.preventDefault();
    var k = current(), t = tiers[k], btn = e.currentTarget;
    btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7';
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root_url + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [
        { id: +d.capVariant, quantity: t.boxes },
        { id: +d.drinkVariant, quantity: t.boxes }
      ] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = root_url + 'discount/' + encodeURIComponent(t.code) + '?redirect=' + encodeURIComponent(root_url + 'checkout');
    }).catch(function () {
      // Fallback: cart permalink
      window.location.href = root_url + 'cart/' + d.capVariant + ':' + t.boxes + ',' + d.drinkVariant + ':' + t.boxes + '?discount=' + encodeURIComponent(t.code);
    });
  }
  $('#dnb-cta').addEventListener('click', buy);
  $('#dnb-st-cta').addEventListener('click', buy);

  // Gallery: swipe, arrows, clickable dots, mouse drag
  var slides = $('#dnb-slides'), dots = $('#dnb-dots');
  if (slides && dots) {
    var st = document.createElement('style');
    st.textContent = '.dnb .gal .nav{position:absolute;top:calc(50% - 22px);transform:translateY(-50%);z-index:3;width:40px;height:40px;border-radius:50%;border:0;background:rgba(255,255,255,.92);color:#18162A;font:700 22px/1 system-ui,sans-serif;display:grid;place-items:center;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.18)}' +
      '.dnb .gal .nav.prev{left:10px}.dnb .gal .nav.next{right:10px}.dnb .gal .nav[disabled]{opacity:0;pointer-events:none}' +
      '.dnb .dots{align-items:center}.dnb .dots button{width:8px;height:8px;padding:0;border:0;border-radius:4px;background:var(--line);cursor:pointer;transition:width .2s}' +
      '.dnb .dots button.on{background:var(--ink);width:20px}' +
      '.dnb .slides{touch-action:pan-x pan-y;-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;cursor:grab}.dnb .slides.drag{cursor:grabbing;scroll-snap-type:none}.dnb .slides img{-webkit-user-drag:none;user-select:none}';
    document.head.appendChild(st);
    var n = slides.children.length, gal = slides.parentNode;
    var html = '';
    for (var i = 0; i < n; i++) html += '<button type="button" aria-label="Show image ' + (i + 1) + '"></button>';
    dots.innerHTML = html; dots.removeAttribute('aria-hidden');
    var prev = document.createElement('button'), next = document.createElement('button');
    prev.type = next.type = 'button'; prev.className = 'nav prev'; next.className = 'nav next';
    prev.setAttribute('aria-label', 'Previous image'); next.setAttribute('aria-label', 'Next image');
    prev.innerHTML = '&#8249;'; next.innerHTML = '&#8250;';
    gal.appendChild(prev); gal.appendChild(next);
    var idx = function () { return Math.round(slides.scrollLeft / slides.clientWidth); };
    var go = function (i) { i = Math.max(0, Math.min(n - 1, i)); slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' }); };
    var mark = function () {
      var i = idx();
      Array.prototype.forEach.call(dots.children, function (dot, j) { dot.classList.toggle('on', j === i); });
      prev.disabled = i <= 0; next.disabled = i >= n - 1;
    };
    prev.addEventListener('click', function () { go(idx() - 1); });
    next.addEventListener('click', function () { go(idx() + 1); });
    Array.prototype.forEach.call(dots.children, function (dot, j) { dot.addEventListener('click', function () { go(j); }); });
    slides.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener('resize', mark);
    // mouse drag (desktop)
    var down = false, sx = 0, start = 0;
    slides.addEventListener('mousedown', function (e) { if (e.button !== 0) return; down = true; sx = e.pageX; start = idx(); slides.classList.add('drag'); e.preventDefault(); });
    window.addEventListener('mouseup', function (e) {
      if (!down) return; down = false; slides.classList.remove('drag');
      var dx = e.pageX - sx;
      if (dx < -40) go(start + 1); else if (dx > 40) go(start - 1);
    });
    mark();
  }

  // UGC previews + modal
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var previews = Array.prototype.slice.call($$('.dnb .vbtn video'));
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); } });
    }, { threshold: 0.5 });
    previews.forEach(function (v) { io.observe(v); });
  }
  var modal = $('#dnb-modal'), mv = $('#dnb-mv');
  if (modal && mv) {
    var close = function () { mv.pause(); mv.removeAttribute('src'); mv.load(); modal.hidden = true; };
    $$('.dnb .vbtn').forEach(function (b) {
      b.addEventListener('click', function () {
        previews.forEach(function (v) { v.pause(); });
        mv.src = b.dataset.v; mv.muted = false; modal.hidden = false; mv.play().catch(function () {});
      });
    });
    $('#dnb-mx').addEventListener('click', close);
    $('#dnb-mbuy').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  // Sticky buy bar once main CTA scrolls away
  var sticky = $('#dnb-sticky');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0]; sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe($('#dnb-cta'));
  } else { sticky.classList.add('on'); }
})();
